import Vue from "vue";

const VpdEventBus = new Vue();

export default VpdEventBus;
